import { ThemeComponentTypes } from '../types'

export const ModalStyleOverrides: ThemeComponentTypes['MuiModal'] = {
  styleOverrides: {
    root: {}
  }
}
